<div class="payment-panel">
    <vb-panel-header
        title="Payment information"
        subtitle="Cards used to settle your invoices.">
        <div panelActions>
            <ng-template #addCardIcon>
                <vb-icon name="plus" [size]="16" [strokeWidth]="2" />
            </ng-template>
            <vb-button
                variant="primary"
                [iconLeft]="addCardIcon"
                (clicked)="goToAddCard()">
                Add card
            </vb-button>
        </div>
    </vb-panel-header>

    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
        <vb-spinner size="xl" label="Loading payment methods"></vb-spinner>
    </div>

    <div
        *ngIf="!isLoading && paymentMethods && paymentMethods.length > 0"
        class="payment-panel__cards">
        <vb-payment-method-row
            *ngFor="let card of paymentMethods"
            [brand]="getCardBrand(card.cardType)"
            [last4]="getCardLast4(card.cardNumber)"
            [expLabel]="getExpLabel(card.expirationDate)"
            [billing]="getBillingLabel(card)"
            [chip]="getCardChip(card)"
            [menuItems]="cardMenuItems"
            (menuSelect)="onCardMenuSelect($event, card)" />
    </div>

    <div
        *ngIf="!isLoading && paymentMethods && paymentMethods.length === 0"
        class="payment-panel__empty">
        No saved cards yet.
    </div>

    <!-- Remove-card confirm — vb-dialog carrying the legacy confirmation's
         copy (sentence-cased per the design voice). -->
    <vb-dialog
        [open]="deleteConfirmOpen"
        tone="danger"
        title="Remove this card?"
        (closed)="closeDeleteConfirm()">
        <p class="payment-panel__confirm-copy">
            Are you sure you want to delete this payment information? This
            action cannot be undone.
        </p>
        <!-- vb-dialog's footer slot stacks children (its full-width recipe);
             a single row wrapper keeps Cancel/Confirm side by side. -->
        <div class="payment-panel__confirm-actions" dialogFooter>
            <vb-button
                variant="ghost"
                [fullWidth]="true"
                (clicked)="closeDeleteConfirm()">
                Cancel
            </vb-button>
            <vb-button
                variant="primary"
                [fullWidth]="true"
                (clicked)="onDeleteConfirmed()">
                Remove card
            </vb-button>
        </div>
    </vb-dialog>
</div>
